import { Button, MultiSelectDropDown } from '@/components/Common';
import { useLessons } from './lessons.hook';

const LessonsFilters = () => {
  const {
    selectedDiscipline,
    classes,
    series,
    filteredLessons,
    handleChangeClasses,
    handleChangeSeries,
    setFormMode,
    setIsOpenLessonModal,
    handleChangeStatus,
  } = useLessons();

  const openCreateModal = () => {
    setFormMode('create');
    setIsOpenLessonModal(true);
  };

  return (
    <div className="flex gap-2 items-center justify-between">
      <div className="flex flex-col">
        <h2 className="text-white text-[32px] font-bold">
          {selectedDiscipline?.name}
        </h2>
        {selectedDiscipline && (
          <span className="text-base not-italic font-normal  text-[#616163]">
            {filteredLessons?.length
              ? `${filteredLessons?.length} leçon(s)`
              : ''}
          </span>
        )}
      </div>

      <div className="flex items-start gap-4 w-[70%]">
        <MultiSelectDropDown
          options={[
            { _id: 'true', name: 'Publié' },
            { _id: 'false', name: 'Brouillon' },
          ]}
          handleChange={handleChangeStatus}
          placeholder="Status"
        />

        <MultiSelectDropDown
          options={classes ? classes : []}
          handleChange={handleChangeClasses}
          placeholder="Selectionner"
        />
        <MultiSelectDropDown
          options={series ? series : []}
          handleChange={handleChangeSeries}
          placeholder="Selectionner"
        />
        <Button title="Ajouter leçon" onClick={openCreateModal} />
      </div>
    </div>
  );
};

export default LessonsFilters;
